/**
 * Storefront "Send as quote": read /cart.js, POST to App Proxy /apps/quotes/cart-quote.
 */
if (!customElements.get('cart-send-as-quote')) {
  class CartSendAsQuote extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.form = this.querySelector('form');
      this.statusEl = this.querySelector('.cart-send-as-quote__status');
      this.submitBtn = this.querySelector('[type="submit"]');
      this.endpoint = this.dataset.endpoint || '/apps/quotes/cart-quote';
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
    }

    setStatus(message, type) {
      if (!this.statusEl) return;
      this.statusEl.hidden = !message;
      this.statusEl.textContent = '';
      this.statusEl.className = 'cart-send-as-quote__status';
      if (!message) return;
      this.statusEl.classList.add(`cart-send-as-quote__status--${type || 'info'}`);
      if (type === 'success' && typeof message === 'object') {
        const p = document.createElement('p');
        p.textContent = message.text;
        this.statusEl.appendChild(p);
        if (message.url) {
          const a = document.createElement('a');
          a.href = message.url;
          a.textContent = message.linkText || message.url;
          a.target = '_blank';
          a.rel = 'noopener';
          this.statusEl.appendChild(a);
        }
      } else {
        this.statusEl.textContent = message;
      }
    }

    async onSubmit(event) {
      event.preventDefault();
      const emailInput = this.form.querySelector('[name="email"]');
      const nameInput = this.form.querySelector('[name="name"]');
      const honeypot = this.form.querySelector('[name="website"]');
      const email = (emailInput?.value || '').trim();
      const name = (nameInput?.value || '').trim();
      const website = (honeypot?.value || '').trim();

      if (!email || !emailInput.checkValidity()) {
        this.setStatus('Please enter a valid email address.', 'error');
        emailInput?.focus();
        return;
      }

      this.submitBtn.disabled = true;
      this.setStatus('Creating your quote…', 'info');

      try {
        const cartRes = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!cartRes.ok) throw new Error('Could not read your cart.');
        const cart = await cartRes.json();

        if (!cart.items || cart.items.length === 0) {
          this.setStatus('Your cart is empty.', 'error');
          return;
        }

        const payload = {
          email,
          name: name || null,
          website,
          cart: {
            token: cart.token,
            items: cart.items.map((item) => ({
              variant_id: item.variant_id,
              id: item.id,
              product_id: item.product_id,
              quantity: item.quantity,
              // Unit prices as shown (gross / tax-inclusive on this store). Prefer final_price.
              price: item.price,
              final_price: item.final_price,
              title: item.product_title || item.title,
              sku: item.sku,
            })),
          },
        };

        const res = await fetch(this.endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify(payload),
        });

        let data = {};
        try {
          data = await res.json();
        } catch (_) {
          data = {};
        }

        if (!res.ok || !data.ok) {
          const detail =
            data.error ||
            (Array.isArray(data.blockers) && data.blockers[0]?.message) ||
            'We could not create your quote. Please try again or call us.';
          this.setStatus(detail, 'error');
          return;
        }

        if (data.emailSent === false && data.publicUrl) {
          this.setStatus(
            {
              text:
                data.message ||
                `Quote ${data.quoteNumber} is ready, but we could not email it. Open your quote:`,
              url: data.publicUrl,
              linkText: 'View quote',
            },
            'success',
          );
        } else {
          this.setStatus(
            {
              text: `Quote ${data.quoteNumber} has been emailed to ${email}. Check your inbox (and spam).`,
              url: data.publicUrl,
              linkText: 'Open quote',
            },
            'success',
          );
        }
        this.form.reset();
      } catch (err) {
        this.setStatus(
          err?.message ||
            'Something went wrong. Please try again or call 023 8045 5129.',
          'error',
        );
      } finally {
        this.submitBtn.disabled = false;
      }
    }
  }

  customElements.define('cart-send-as-quote', CartSendAsQuote);
}
